import Snappy from '../../../libs/snappy/snappy';
import Handlebars from 'handlebars';

Snappy.Component.LatestScoresFixtures = class LatestScoresFixtures extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-latest-scores-fixtures';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
		this.setVars();
		this.loadOptaWidget();
		this.setEventListeners();
		this.setButtonStates();
	}
	
	setVars() {
		this.componentErrorClass = 'fa-latest-scores-fixtures--error';
		this.optaUid = this.$element.data('uid');
		this.onOptaDataReceived = this.onOptaWidgetRendered;
		this.optaTemplate = this.$element.find('#opta-template');
		this.$tournamentSelect = this.$element.find('.fa-dropdown__select');
		this.$fixturesContainer = this.$element.find('.fixtures-holder');
		this.componentLoadingClass = 'fa-latest-scores-fixtures--loading';
		this.$fixturesCta = this.$element.find('.extra-controls__cta.fixtures');
		this.$resultsCta = this.$element.find('.extra-controls__cta.results');
		this.$ecalCta = this.$element.find('.extra-controls__cta.ecal');
		this.$errorResultsLink = this.$element.find('.error-holder a');
	}
	
	setEventListeners() {
		this.$tournamentSelect.on('change', this.onTournamentChange.bind(this));
	}
	
	loadOptaWidget() {
		const optaCompetitionId =  this.activeOptaCompetitionId = this.$tournamentSelect.val();
		const optaCompetitionSeason = this.$tournamentSelect.find(`option[value="${optaCompetitionId}"]`).data('season');
		const context = {
			optaCompetitionId,
			optaCompetitionSeason
		};
		const template = Handlebars.compile(this.optaTemplate.html());
		
		if (this.dataTimeout) {
			window.clearTimeout(this.dataTimeout);
		}
		
		let html = template(context);
		html = html.replace('load="false"', '');
		this.$element.removeClass(this.componentErrorClass);
		this.isLoadingData = true;
		this.$fixturesContainer.append(html);
		this.resumeOpta();
		this.setDataTimeout();
	}
	
	onOptaWidgetRendered(widget, isError) {
		if (this.isLoadingData) {
			this.$element.removeClass(this.componentLoadingClass);
			this.activeOptaWidget = this.$fixturesContainer.find('div').attr('id');
			
			if (isError || !widget.matches.length) {
				this.onDataError();
			}
			
			this.isLoadingData = false;
		}
	}
	
	setDataTimeout() {
		this.dataTimeout = window.setTimeout(this.cancelDataCall.bind(this), 6000);
	}
	
	cancelDataCall() {
		if (this.isLoadingData) {
			this.isLoadingData = false;
			this.$element.removeClass(this.componentLoadingClass);
			this.onDataError();
		}
	}
	
	onDataError() {
		const resultsPath = this.$tournamentSelect.find(`option[value="${this.activeOptaCompetitionId}"]`).data('resultsLink');
		
		this.$element.addClass(this.componentErrorClass);
		this.$errorResultsLink.attr('href', resultsPath);
		this.$errorResultsLink.toggleClass('show', !!resultsPath.length);
	}
	
	resumeOpta() {
		if (window.Opta) {
			window.Opta.start();
		}
	}
	
	destroyOptaInstance() {
		const optaInstance = Opta.widgets[this.activeOptaWidget];
		
		if (optaInstance) {
			optaInstance.destroy(true);
		}
	}
	
	onTournamentChange() {
		this.destroyOptaInstance();
		this.$fixturesContainer.empty();
		this.$element.addClass(this.componentLoadingClass);
		this.loadOptaWidget();
		this.setButtonStates();
	}
	
	setButtonStates() {
		const $option = this.$tournamentSelect.find(`option[value="${this.activeOptaCompetitionId}"]`);
		const showFixtures = $option.data('fixturesLink');
		const showResults = $option.data('resultsLink');
		const showEcal = $option.data('showEcal');
		
		if (showFixtures) {
			this.$fixturesCta.find('a').attr('href', showFixtures);
		}
		
		if (showResults) {
			this.$resultsCta.find('a').attr('href', showResults);
		}
		
		this.$fixturesCta.toggleClass('show', !!showFixtures);
		this.$resultsCta.toggleClass('show', !!showResults);
		this.$ecalCta.toggleClass('show', showEcal);
	}
};



// WEBPACK FOOTER //
// ./components/latestScoresFixtures/scripts/latestScoresFixtures.js